import { useEffect, useState, type ReactElement } from 'react';
import { dispensar, ouvirAvisos, type Aviso } from '../lib/aviso-de-erro';
import { Icon } from './Icon';
import { useT } from '../lib/i18n';
import '../styles/avisos.css';

const DURACAO_MS = 10_000;

export function AvisosDeErro(): ReactElement | null {
  const t = useT();
  const [avisos, setAvisos] = useState<readonly Aviso[]>([]);

  useEffect(() => ouvirAvisos(setAvisos), []);

  if (avisos.length === 0) return null;
  return (
    <div className="avisos" role="region" aria-label={t.ui.avisos}>
      {avisos.map((a) => (
        <CartaoDeAviso key={a.id} aviso={a} />
      ))}
    </div>
  );
}

function CartaoDeAviso({ aviso }: { readonly aviso: Aviso }): ReactElement {
  const t = useT();
  useEffect(() => {
    const id = window.setTimeout(() => dispensar(aviso.id), DURACAO_MS);
    return () => window.clearTimeout(id);
  }, [aviso.id]);

  return (
    <div className="aviso" role="alert">
      <Icon name="alert" size={16} />
      <p className="aviso__texto">{aviso.texto}</p>
      <button
        type="button"
        className="aviso__fechar"
        onClick={() => dispensar(aviso.id)}
        aria-label={t.ui.fecharAviso}
      >
        <Icon name="x" size={14} />
      </button>
    </div>
  );
}
